import { Controller } from "@hotwired/stimulus"

// Переключает блоки полей «готовая» / «необработанная» по выбранному kind.
export default class extends Controller {
  static targets = ["kind", "finished", "raw"]

  connect() {
    this.toggle()
  }

  toggle() {
    const kind = this.selectedKind()
    this.finishedTarget.hidden = kind !== "finished"
    this.rawTarget.hidden = kind !== "raw"
  }

  selectedKind() {
    const checked = this.kindTargets.find((el) => el.checked)
    return checked ? checked.value : "finished"
  }
}
